import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum ScanDocumentStep {
  Scan = 'Scan',
  Fail = 'Fail',
  Bypass = 'Bypass',
}

export const scanDocumentFlow: CheckinWorkflow<ScanDocumentStep> = {
  id: FlowId.ScanDocument,
  entry: ScanDocumentStep.Scan,
  steps: {
    [ScanDocumentStep.Scan]: {
      id: ScanDocumentStep.Scan,
      page: PageKey.SCAN_DOCUMENT,
      next: (variables) =>
        variables.isScanDocumentSuccess ? { complete: true } : { nextStep: ScanDocumentStep.Fail },
    },
    [ScanDocumentStep.Fail]: {
      id: ScanDocumentStep.Fail,
      page: PageKey.IDENTITY_COMPARISON_FAIL,
      next: () => ({ bubble: 'exit' }),
      bypass: () => ({ nextStep: ScanDocumentStep.Bypass }),
    },
    [ScanDocumentStep.Bypass]: {
      id: ScanDocumentStep.Bypass,
      page: PageKey.BYPASS,
      next: () => ({ complete: true }),
      back: () => ({ nextStep: ScanDocumentStep.Scan }),
    },
  },
};
